/*
 * Public API Surface of angular-grit-universal
 */

export * from './lib/proxies';
export { BooleanValueAccessor } from './lib/boolean-value-accessor';
export { NumericValueAccessor } from './lib/number-value-accessor';
export { SelectValueAccessor } from './lib/select-value-accessor';
export { TextValueAccessor } from './lib/text-value-accessor';

// Package module

export { GritUniversalModule } from './grit-universal-module';

// We should add typings
export type { GritCheckboxEventData } from '@progleasing/grit-universal';
export type { GritPickerEventData } from '@progleasing/grit-universal';
export type { GritRadioEventData } from '@progleasing/grit-universal';
export type { GritSliderEventData } from '@progleasing/grit-universal';
export type { GritFormatter } from '@progleasing/grit-universal';
export type { GritValidator } from '@progleasing/grit-universal';
export type { FlagNotification } from '@progleasing/grit-universal';

export * from '@progleasing/grit-universal';
